
	module.exports = require('../Sphere').SphereFunction;




//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/geom/mesh/SphereFunction.js
// module id = 4596
// module chunks = 15